/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const GSLBEnum = {
    GET_GSLB_FRONTENDS: '/gslb/globalnames',
    GET_GSLB_GLOBALNAME: (id: string): string => {
        return '/gslb/globalnames/' + id;
    },
    POST_GSLB_FRONTEND: '/gslb/globalnames',
    PUT_GSLB_FRONTEND: (id: string): string => {
        return '/gslb/globalnames/' + id;
    },
    DELETE_GSLB_FRONTEND: (id: string): string => {
        return '/gslb/globalnames/' + id;
    },
    GET_GSLB_RIPS: '/gslb/members',
    GET_GSLB_MEMBER: (id: string): string => {
        return '/gslb/members/' + id;
    },
    POST_GSLB_RIP: '/gslb/members',
    PUT_GSLB_RIP: (id: string): string => {
        return '/gslb/members/' + id;
    },
    DELETE_GSLB_RIP: (id: string): string => {
        return '/gslb/members/' + id;
    },

    GET_GSLB_BACKENDS: '/gslb/pools',
    GET_GSLB_POOL: (id: string): string => {
        return '/gslb/pools/' + id;
    },
    POST_GSLB_BACKEND: '/gslb/pools',
    PUT_GSLB_BACKEND: (id: string): string => {
        return '/gslb/pools/' + id;
    },
    DELETE_GSLB_BACKEND: (id: string): string => {
        return '/gslb/pools/' + id;
    },

    GET_GSLB_HEALTHCHECK_REPORTS: '/gslb/stats/generic-state',

    GET_GSLB_DISTRIBUTION_REPORTS: '/gslb/stats/ppdns-state',

    GET_GSLB_TOPOLOGIES: '/gslb/topologies',
    GET_GSLB_TOPOLOGY: (id: string): string => {
        return '/gslb/topologies/' + id;
    },
    POST_GSLB_TOPOLOGY: '/gslb/topologies',
    PUT_GSLB_TOPOLOGY: (id: string): string => {
        return '/gslb/topologies/' + id;
    },
    DELETE_GSLB_TOPOLOGY: (id: string): string => {
        return '/gslb/topologies/' + id;
    }
};
